/**
 * @category Indexer Grpc Transformer
 */
export class IndexerGrpcAuctionTransformer {
    static grpcAuctionCoinToAuctionCoin(grpcCoin) {
        return {
            denom: grpcCoin.denom,
            amount: grpcCoin.amount,
            usdValue: grpcCoin.usdValue,
        };
    }
    static grpcAuctionCoinPricesToAuctionCoinPrices(grpcCoinPrices) {
        return {
            denom: grpcCoinPrices.denom,
            amount: grpcCoinPrices.amount,
            prices: grpcCoinPrices.prices,
        };
    }
    static grpcBidToBid(grpcBid) {
        return {
            bidder: grpcBid.bidder,
            bidAmount: grpcBid.amount,
            bidTimestamp: parseInt(grpcBid.timestamp, 10),
        };
    }
    static grpcAuctionToAuction(grpcAuction) {
        return {
            winner: grpcAuction.winner,
            basket: grpcAuction.basket.map(IndexerGrpcAuctionTransformer.grpcAuctionCoinToAuctionCoin),
            winningBidAmount: grpcAuction.winningBidAmount,
            round: parseInt(grpcAuction.round, 10),
            endTimestamp: parseInt(grpcAuction.endTimestamp, 10),
            updatedAt: parseInt(grpcAuction.updatedAt, 10),
        };
    }
    static grpcAuctionV2ToAuctionV2(grpcAuction) {
        return {
            winner: grpcAuction.winner,
            basket: grpcAuction.basket.map(IndexerGrpcAuctionTransformer.grpcAuctionCoinPricesToAuctionCoinPrices),
            winningBidAmount: grpcAuction.winningBidAmount,
            round: parseInt(grpcAuction.round, 10),
            endTimestamp: parseInt(grpcAuction.endTimestamp, 10),
            updatedAt: parseInt(grpcAuction.updatedAt, 10),
        };
    }
    static grpcAccountAuctionV2ToAccountAuctionV2(grpcAccountAuction) {
        return {
            id: grpcAccountAuction.id,
            round: parseInt(grpcAccountAuction.round, 10),
            amountDeposited: grpcAccountAuction.amountDeposited,
            isClaimable: grpcAccountAuction.isClaimable,
            claimedAssets: grpcAccountAuction.claimedAssets.map(IndexerGrpcAuctionTransformer.grpcAuctionCoinPricesToAuctionCoinPrices),
        };
    }
    static auctionsResponseToAuctions(response) {
        return response.auctions.map((a) => IndexerGrpcAuctionTransformer.grpcAuctionToAuction(a));
    }
    static auctionsHistoryV2ResponseToAuctionHistory(response) {
        return {
            auctions: response.auctions.map(IndexerGrpcAuctionTransformer.grpcAuctionV2ToAuctionV2),
            next: response.next,
        };
    }
    static accountAuctionsV2ResponseToAccountAuctionsV2(response) {
        return {
            auctions: response.auctions.map(IndexerGrpcAuctionTransformer.grpcAccountAuctionV2ToAccountAuctionV2),
            next: response.next,
            total: response.total,
        };
    }
    static auctionResponseToAuction(response) {
        return {
            auction: IndexerGrpcAuctionTransformer.grpcAuctionToAuction(response.auction),
            bids: response.bids.map(IndexerGrpcAuctionTransformer.grpcBidToBid),
        };
    }
}
